import React from 'react';
import styles from './Table.module.scss';
import { Table as TableAntd } from 'antd';
import { callListColumns } from '../../constants/constants';

const Table = ({
  data = [],
  onRowClick,
  operatorsFilters,
  companiesFilters,
  value,
}) => {
  const columns = callListColumns({ operatorsFilters, companiesFilters });

  const getRowClassName = (record) => {
    return record.uniqueId === value?.uniqueId ? styles.selectedRows : '';
  };

  return (
    <TableAntd
      dataSource={data}
      columns={columns}
      onRow={(record) => {
        return {
          onClick: () => onRowClick(record),
        };
      }}
      getPopupContainer={(trigger) => trigger.parentNode}
      rowClassName={getRowClassName}
      pagination={{
        pageSize: 7,
      }}
    />
  );
};

export default Table;
